<div class="n-tela-cadastro">
  <div class="n-container">
    <!-- Conteúdo principal em duas colunas -->
    <div class="n-tela-cadastro-content">
      <!-- Coluna esquerda - Informações -->
      <div class="n-tela-cadastro-info">
        <!-- Logo e botão de boas-vindas -->
        <div class="n-header-info">
          <img
            class="n-logo n-logo-clickable"
            src="assets/icons/nomoh_logo.svg"
            alt="Nomoh Logo"
            (click)="navegarHome()"
            role="link"
            tabindex="0"
            (keydown.enter)="navegarHome()"
          />
          <button class="n-welcome-btn" disabled>
            <i class="pi pi-star"></i>
            {{ 'PAGINA_CADASTRO.BEM_VINDO_NOMOH_HORIZON' | translate }}
          </button>
        </div>

        <!-- Título principal -->
        <div class="n-title-section">
          <h1 class="n-main-title">
            {{ 'PAGINA_CADASTRO.CRIE_SUA_CONTA' | translate }}
            <strong>{{ 'PAGINA_CADASTRO.FACLITE_SEU_DIA' | translate }}</strong>
            {{ 'PAGINA_CADASTRO.COM_NOSSAS_SOLUCOES' | translate }}
          </h1>
          <p class="n-main-subtitle">
            {{ 'PAGINA_CADASTRO.TRANSFORME_GESTAO' | translate }}
          </p>
        </div>

        <!-- Lista de benefícios -->
        <div class="n-benefits-list">
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_CADASTRO.FACLITE_SEU_DIA' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_CADASTRO.ORGANIZACAO_DADOS' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_CADASTRO.GESTAO_ENDERECOS' | translate }}</span>
          </div>
          <div class="n-benefit-item">
            <i class="pi pi-check n-check-icon"></i>
            <span>{{ 'PAGINA_CADASTRO.INTEGRACAO_COM' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Coluna direita - Formulário / Confirmação -->
      <div class="n-tela-cadastro-form">
        <div class="n-form-card">
          @if (cadastroConcluido()) {
          <!-- Step 2: Confirmação de e-mail -->
          <div class="n-sucesso-container">
            <!-- Ícone animado -->
            <div class="n-sucesso-icone-wrapper">
              <div class="n-sucesso-icone-ring n-ring-3"></div>
              <div class="n-sucesso-icone-ring n-ring-2"></div>
              <div class="n-sucesso-icone-ring n-ring-1"></div>
              <div class="n-sucesso-icone">
                <i class="pi pi-envelope"></i>
              </div>
              <div class="n-sucesso-check">
                <i class="pi pi-check"></i>
              </div>
            </div>

            <!-- Título e saudação -->
            <div class="n-sucesso-header">
              <h2 class="n-sucesso-titulo">
                {{ 'PAGINA_CADASTRO.SUCESSO_TITULO' | translate }}
              </h2>
              <p class="n-sucesso-saudacao">
                {{ 'PAGINA_CADASTRO.SUCESSO_SAUDACAO_PREFIXO' | translate }}
                <strong class="n-sucesso-nome">{{ nomeCadastrado() }}</strong
                >!
                {{ 'PAGINA_CADASTRO.SUCESSO_SAUDACAO_SUFIXO' | translate }}
              </p>
            </div>

            <!-- E-mail destacado -->
            <div class="n-sucesso-email-wrapper">
              <p class="n-sucesso-instrucao">
                {{ 'PAGINA_CADASTRO.SUCESSO_INSTRUCAO' | translate }}
              </p>
              <div class="n-sucesso-email">
                <i class="pi pi-at"></i>
                <span>{{ emailCadastrado() }}</span>
              </div>
            </div>

            <!-- Passos -->
            <div class="n-sucesso-passos">
              <div class="n-sucesso-passo">
                <div class="n-passo-icone">
                  <i class="pi pi-inbox"></i>
                </div>
                <div class="n-passo-texto">
                  <span class="n-passo-label">Passo 1</span>
                  <p>{{ 'PAGINA_CADASTRO.SUCESSO_PASSO_1' | translate }}</p>
                </div>
              </div>
              <div class="n-sucesso-divisor"></div>
              <div class="n-sucesso-passo">
                <div class="n-passo-icone n-passo-icone--warn">
                  <i class="pi pi-exclamation-triangle"></i>
                </div>
                <div class="n-passo-texto">
                  <span class="n-passo-label">Passo 2</span>
                  <p>
                    {{ 'PAGINA_CADASTRO.SUCESSO_PASSO_2_PREFIXO' | translate }}
                    <strong>{{
                      'PAGINA_CADASTRO.SUCESSO_PASSO_2_SPAM' | translate
                    }}</strong>
                    {{ 'PAGINA_CADASTRO.SUCESSO_PASSO_2_SUFIXO' | translate }}
                  </p>
                </div>
              </div>
              <div class="n-sucesso-divisor"></div>
              <div class="n-sucesso-passo">
                <div class="n-passo-icone n-passo-icone--success">
                  <i class="pi pi-verified"></i>
                </div>
                <div class="n-passo-texto">
                  <span class="n-passo-label">Passo 3</span>
                  <p>{{ 'PAGINA_CADASTRO.SUCESSO_PASSO_3' | translate }}</p>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <!-- Header do formulário -->
          <div class="n-form-header">
            <!-- <h2 class="n-form-title">{{ "PAGINA_CADASTRO.TITULO" | translate }}</h2> -->
            <p class="n-form-subtitle">
              {{ 'PAGINA_CADASTRO.SIGA_PASSOS' | translate }}
            </p>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()" class="n-form-grid">
            <!--
            FOTO DE PERFIL - temporariamente oculto (reativar quando necessário)
            Upload de Foto de Perfil
            <div class="n-form-section">
              <div class="n-upload-container">
                <div class="n-avatar-wrapper">
                  <div class="n-avatar" [class.n-has-image]="filePreviewUrl">
                    @if (filePreviewUrl) {
                    <img
                      [src]="filePreviewUrl"
                      alt="Preview da foto"
                      class="n-avatar-image"
                    />
                    } @else {
                    <i class="pi pi-user n-avatar-icon"></i>
                    }
                  </div>

                  <div class="n-upload-actions">
                    <p-fileUpload
                      #fileUpload
                      name="foto[]"
                      accept="image/*"
                      [maxFileSize]="10000000"
                      (onSelect)="imagemSelecionada($event, fileUpload)"
                      mode="basic"
                      [auto]="true"
                      chooseIcon="pi pi-camera"
                      [chooseLabel]="placeHolderBotaoImagem"
                      class="n-upload-btn"
                    ></p-fileUpload>

                    @if (filePreviewUrl) {
                    <button
                      type="button"
                      pButton
                      icon="pi pi-trash"
                      class="p-button-rounded p-button-sm p-button-danger n-remove-btn"
                      (click)="removerImagem()"
                    >
                      <span class="sr-only">Remover imagem</span>
                    </button>
                    }
                  </div>
                </div>
                <small class="n-upload-hint">{{
                  'PAGINA_CADASTRO.ADCIONAR_FOTO' | translate
                }}</small>
              </div>
            </div>
            -->

            <!-- Dados Pessoais -->
            <div class="n-form-section">
              <h3 class="n-section-title">
                <i class="pi pi-user"></i>
                {{ 'PAGINA_CADASTRO.TITULO_DADOS_PESSOAIS' | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.NOME_COMPLETO' | translate }}"
                    controlName="nomeCompleto"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="nomeCompleto"
                      [placeholder]="placeholderNomeCompleto"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.DATA_NASCIMENTO' | translate }}"
                    controlName="dataNascimento"
                    [required]="true"
                  >
                    <p-datepicker
                      formControlName="dataNascimento"
                      [showIcon]="true"
                      dateFormat="dd/mm/yy"
                      [maxDate]="hoje"
                      [placeholder]="'GLOBAL.SELECIONE_DATA' | translate"
                      styleClass="w-full"
                    />
                  </lib-form-field>
                </div>

                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.TELEFONE' | translate }}"
                    controlName="telefone"
                    [required]="true"
                  >
                    <lib-phone-input
                      [value]="form.get('telefone')?.value ?? ''"
                      (valueChange)="onTelefoneChange($event)"
                    />
                  </lib-form-field>
                </div>

                <div class="n-field n-field-full">
                  <lib-form-field
                    label="{{ 'GLOBAL.EMAIL' | translate }}"
                    controlName="email"
                    [required]="true"
                  >
                    <input
                      pInputText
                      formControlName="email"
                      type="email"
                      [placeholder]="placeholderEmail"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>

                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.SEXO' | translate }}"
                    controlName="sexo"
                  >
                    @if (isMobileView()) {
                    <lib-n-multiselect
                      [multiple]="false"
                      formControlName="sexo"
                      [options]="sexoOpcoes"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'GLOBAL.SELECIONE_SEXO' | translate"
                    />
                    } @else {
                    <p-select
                      [options]="sexoOpcoes"
                      formControlName="sexo"
                      optionLabel="label"
                      optionValue="value"
                      [placeholder]="'GLOBAL.SELECIONE_SEXO' | translate"
                      [styleClass]="'w-full'"
                    />
                    }
                  </lib-form-field>
                </div>
                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.CPF' | translate }}"
                    controlName="cpfCnpj"
                    [required]="false"
                  >
                    <input
                      pInputText
                      formControlName="cpfCnpj"
                      (input)="formatarCpfCnpj($event)"
                      placeholder="000.000.000-00"
                      autocomplete="off"
                    />
                  </lib-form-field>
                </div>
              </div>
            </div>

            <!-- Segurança -->
            <div class="n-form-section" formGroupName="seguranca">
              <h3 class="n-section-title">
                <i class="pi pi-lock"></i>
                {{ 'PAGINA_CADASTRO.TITULO_SENHAS' | translate }}
              </h3>

              <div class="n-field-group">
                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.SENHA' | translate }}"
                    controlName="senha"
                    [required]="true"
                  >
                    <p-password
                      formControlName="senha"
                      autocomplete="off"
                      [toggleMask]="true"
                      [strongRegex]="regexSenha"
                      [placeholder]="placeholderSenha"
                      [feedback]="true"
                      styleClass="w-full"
                    >
                      <ng-template pTemplate="footer">
                        <div class="n-password-requirements">
                          <p class="n-requirements-title">
                            {{ 'GLOBAL.SENHA_CONTER' | translate }}
                          </p>
                          <ul class="n-requirements-list">
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasUpperCase()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasUpperCase() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              {{ 'GLOBAL.UMA_LETRA_MAIUSCULA' | translate }}
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasLowerCase()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasLowerCase() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              {{ 'GLOBAL.UMA_LETRA_MINUSCULA' | translate }}
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasNumber()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasNumber() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              {{ 'GLOBAL.UM_NUMERO' | translate }}
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasSpecialChar()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasSpecialChar() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              {{ 'GLOBAL.UM_CARACTERE_ESPECIAL' | translate }}
                            </li>
                            <li
                              class="n-requirement-item"
                              [ngClass]="{
                                'n-requirement-valid': hasMinLength()
                              }"
                            >
                              <i
                                class="pi"
                                [ngClass]="
                                  hasMinLength() ? 'pi-check' : 'pi-times'
                                "
                              ></i>
                              {{ 'GLOBAL.MINIMO_CARACTERES' | translate }}
                            </li>
                          </ul>
                        </div>
                      </ng-template>
                    </p-password>
                  </lib-form-field>
                </div>

                <div class="n-field n-field-large">
                  <lib-form-field
                    label="{{ 'GLOBAL.CONFIRMAR_SENHA' | translate }}"
                    controlName="confirmarSenha"
                    [required]="true"
                  >
                    <p-password
                      formControlName="confirmarSenha"
                      [feedback]="false"
                      [toggleMask]="true"
                      [placeholder]="placeholderConfirmarSenha"
                      autocomplete="off"
                    ></p-password>
                  </lib-form-field>
                </div>
              </div>
            </div>

            <!-- Botões de Ação -->
            <div class="n-form-actions">
              <p-button
                (onClick)="cancelar()"
                [disabled]="isLoading()"
                severity="secondary"
                styleClass="n-button-sec"
                type="button"
              >
                {{ 'GLOBAL.CANCELAR' | translate }}
              </p-button>

              <p-button
                [loading]="isLoading()"
                styleClass="n-button-prim"
                type="submit"
              >
                {{ 'GLOBAL.SALVAR' | translate }}
              </p-button>
            </div>
          </form>
          }
          <!-- fim @else -->
        </div>
      </div>
    </div>
  </div>
</div>
